import { ETHNIC_ORIGIN_ACTIONS } from 'constants/Actions/EthnicOrigins';

// Estado inicial del reducer
const aInitialState = {
    aEthnicOrigins: [],
    oEthnicOrigin: null,
    aEthnicOriginsList: [],

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que será utilizado para controlar los datos referidos a los origenes etnicos almacenados en el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const EthnicOriginReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case ETHNIC_ORIGIN_ACTIONS.GET:
            return { ...aState, aEthnicOrigins: oAction.data };
        case ETHNIC_ORIGIN_ACTIONS.GET_LIST:
            return { ...aState, aEthnicOriginsList: oAction.data };
        case ETHNIC_ORIGIN_ACTIONS.FIND:
            return { ...aState, oEthnicOrigin: oAction.data };
        case ETHNIC_ORIGIN_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case ETHNIC_ORIGIN_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        case ETHNIC_ORIGIN_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oEthnicOrigin: null };
        default:
            return aState;
    }
}
